import * as CONFIGS from "@/statics/configs.js";

const NODE15 = {
  NAME: "TC1C",
  INPUT1: {
    NAME: "NODE15_INPUT1_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8020,
  },
  
  OUTPUT1: {
    NAME: "NODE15_OUTPUT1_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe010,
  },
  
  TEMPERATURE: {
    NAME: "NODE15_TEMPERATURE_NAME",
    TYPE: "internalTemperature",
    ICON: "temperature",
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xe110,
  },
  RELAY2_INIT: {
    PARAMETER_ID: 0xe111,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
};

NODE15.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE15.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE15.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE15.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE15.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    
    
  ],
];
export default NODE15;
